angular.module('core', [
    'settings',
    'modals',
    'ngClipboard',
    'ngCookies',
    'sessionTimeoutInterceptor',
    'errorInterceptor',
    'numeration',
    'pascalprecht.translate',
    'ngResource',
    'ui.select',
    'ui.tinymce',
    'angularMoment',
    'daterangepicker',
    'ui.bootstrap-slider',
    'toastr',
    'language',
    'urlbuilder',
    'user',
    'angular-loading-bar',
    'ae-datetimepicker',
    'ngLetterAvatar',
    'colorpicker.module',
    'nya.bootstrap.select',
    'ui.validate',
    'angularPromiseButtons',
    'angular-flatpickr',
    'angularjs-dropdown-multiselect',
    'ngSanitize',
    'ui.router',
    'angular.filter',
    'mentio',
    'ui.mention',
    'xeditable',
    // 'dndLists'
])
    .constant('SYSTEM_SETTINGS', {
        "LOGIN_SHOWLOGO": true
    })
    .config(['uiSelectConfig', function (uiSelectConfig) {
        // uiSelectConfig.theme = 'bootstrap';
        uiSelectConfig.resetSearchInput = true;
        // uiSelectConfig.appendToBody = true;
        uiSelectConfig.theme = 'select2';
    }])

    .service('KeyboardShortcutsService', function ($rootScope, $window) {
        const unsubscribers = []

        this.register = (bindings, options) => {
            const tinykeys = $window.tinykeys && $window.tinykeys.tinykeys
            if (!angular.isFunction(tinykeys)) {
                return angular.noop
            }

            options = options || {}
            const preventDefault = options.preventDefault !== false
            const tinykeysOptions = angular.extend({}, options)
            delete tinykeysOptions.preventDefault

            const wrappedBindings = {}
            angular.forEach(bindings, (handler, combo) => {
                if (!angular.isFunction(handler)) {
                    return
                }
                wrappedBindings[combo] = event => {
                    if (preventDefault) {
                        event.preventDefault()
                    }
                    $rootScope.$evalAsync(() => handler(event))
                }
            })

            const unsubscribe = tinykeys($window, wrappedBindings, tinykeysOptions)
            unsubscribers.push(unsubscribe)

            return () => {
                unsubscribe()
                const index = unsubscribers.indexOf(unsubscribe)
                if (index !== -1) {
                    unsubscribers.splice(index, 1)
                }
            }
        }

        this.unregisterAll = () => {
            while (unsubscribers.length) {
                unsubscribers.pop()()
            }
        }
    })

    .service('PublicSettingsService', function ($http) {
        let settingsRequest;

        this.get = () => {
            if (!settingsRequest) {
                settingsRequest = $http.get('/crm/api/public/settings')
                    .then(response => response && response.data ? response.data : {})
                    .catch(() => ({}));
            }
            return settingsRequest;
        };
    })

    .filter('trustAsResourceUrl', function ($sce) {
        return val => $sce.trustAsResourceUrl(val);
    })
    .filter('initials', function () {
        return value => {
            if (!angular.isString(value)) {
                return ''
            }

            const words = value.trim().split(/[\s/-]+/).filter(Boolean)

            return words
                .map(word => word.charAt(0))
                .join('')
                .toUpperCase()
        }
    })
    .run(function (KeyboardShortcutsService, UserService) {
        KeyboardShortcutsService.register({
            '$mod+KeyU': () => UserService.searchUserModal()
        }, {
            capture: true,
            ignore: event => event.repeat || event.isComposing
        })
    })
    .run(function ($rootScope, $location, SYSTEM_SETTINGS) {
        $rootScope.SYSTEM_SETTINGS = SYSTEM_SETTINGS;
        $rootScope.isActivePath = path => $location.path() === path;
    })
    .config(function ($cookiesProvider) {
        $cookiesProvider.defaults.expires = moment().add(4, 'week').toDate();
    })
    .config(function (nyaBsConfigProvider) {
        nyaBsConfigProvider.setLocalizedText("pl-PL", {
            defaultNoneSelection: '-- wybierz --',
            noSearchResult: 'brak rekordów',
            numberItemSelected: 'Zaznaczono - %d ',
            selectAll: 'Zaznacz wszystko',
            deselectAll: 'Odznacz wszystko'
        });
        nyaBsConfigProvider.useLocale("pl-PL");
    })
    .config(function (cfpLoadingBarProvider) {
        cfpLoadingBarProvider.latencyThreshold = 5000;
    })
    .config(function (angularPromiseButtonsProvider) {
        angularPromiseButtonsProvider.extendConfig({
            spinnerTpl: ''
        });
    })
    .run(function ($trace, ENV) {
        if (ENV === "dev") {
            $trace.enable('TRANSITION');
        }
    })
    .run(function (stateHandler) {
        stateHandler.initialize();
    })
    .run(function (editableOptions, editableThemes) {
        editableOptions.theme = 'bs3'; // bootstrap3 theme. Can be also 'bs4', 'bs2', 'default'
        editableThemes.bs3.buttonsClass = 'btn-xs';
    })
    .config(function ($uibTooltipProvider) {
        $uibTooltipProvider.options({
            appendToBody: true,
            popoverAppendToBody: true
        });
    })
    .config(function ($compileProvider) {
        let oldWhiteList = $compileProvider.aHrefSanitizationWhitelist();
        $compileProvider.aHrefSanitizationWhitelist(/^\s*(https?|ftp|mailto|tel|file|webcal):/);
    })
    .config(function ($locationProvider, $qProvider) {
        $locationProvider.hashPrefix(''); //default AngularJS 1.6: ! <a href="#!/add-quote">Add Quote</a>
        $qProvider.errorOnUnhandledRejections(false); //AngularJS 1.6 propably unhandled rejection $promise.then(fn).catch(fn)
        //https://stackoverflow.com/questions/20969835/angularjs-login-and-authentication-in-each-route-and-controller/29797145#29797145
    })
    .config(function ($urlMatcherFactoryProvider) {
        $urlMatcherFactoryProvider.type('boolean', {
            name: 'boolean',
            decode: val => val === true || val === 'true' || val === 1 || val === "1",
            encode: val => val ? 1 : 0,
            equals: function (a, b) {
                return this.is(a) && a === b;
            },
            is: val => [true, false, 0, 1].includes(val),
            pattern: /bool|true|0|1/
        });
        $urlMatcherFactoryProvider.type('number', {
            name: 'number',
            decode: val => Number(val),
            encode: val => val,
            equals: (a, b) => a === b,
            is: val => !isNaN(parseFloat(val)) && isFinite(val)
        });
        $urlMatcherFactoryProvider.type('datetimeiso', {
            name: 'datetimeiso',
            decode: myDateValue => {
                let timestamp;

                if (angular.isDate(myDateValue)) {
                    return myDateValue.toISOString();
                }

                timestamp = Date.parse(myDateValue);

                if (!isNaN(timestamp)) {
                    return new Date(timestamp).toISOString();
                }
            },
            encode: val => val,
            // equals: function(a, b) { return a === b; },
            is: function (myDateValue) {
                return angular.isDefined(myDateValue) && this.decode(myDateValue) === myDateValue;
            }
        });
    })
    .config(function ($stateProvider, $urlRouterProvider) {
        $urlRouterProvider.otherwise('/');
        $stateProvider.state('authenticated', {
            abstract: true,
            resolve: {
                bodyStyleUnauthenticated: $rootScope => $rootScope.globalUserUnauthenticated = false
            }
        });
        $stateProvider.state('app', {
            abstract: true,
            parent: 'authenticated',
            views: {
                'navbar@': {
                    templateUrl: 'app/dashboard/navbar/navbar-top.tpl.html',
                    controller: 'NavbarTopCtrl'
                },
                'sidebar@': {
                    templateUrl: 'app/dashboard/navbar/navbar-left.tpl.html',
                    controller: 'NavbarLeftCtrl'
                }
            },
            resolve: {
                translatePartialLoader: $translate => {
                    $translate.refresh();
                }
            }
        });
    })
